module.exports = __webpack_public_path__ + "media/1.0e038c94.mp3";